import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <section style={{
    backgroundImage: `url("../img/login-bg.jpg")`
  }} className="bg-login-bkimg">

    <div style={{ right: `10%` }} className="row p-absolute-resp p-3">
      
      <div className="col-lg-11">
        <div className="card bg-transparent bd-transparent border-0 mb-0">
          <div className="card-body py-0">
            <Link to="/"><img className="logo" alt="logo" src="/img/sterling-logo.svg" /></Link>
          </div>
        </div>
      </div>
    </div>
    <div className="container-fluid p-0">
      <div className="row min-vh-100 rowreversed-resp login-card">
        <div className="col-lg-1 d-md-block d-none my-auto mx-auto p-0 m-0">

        </div>
        <div className="col-lg-4 my-auto mx-auto">
          <div className="card bg-pale-b border-0 shadow shadow-showcase b-r-5">
            
          </div>
        </div>

        <div className="col-lg-7 my-auto mx-auto py-5">
          <div className="card bg-transparent bd-transparent border-0">
            <div className="card-body">
              <h1 className="text-white mb-3">The page you're looking for doesnt exist</h1>
              <h4 className="text-white font-light f-w-400">Go <Link to ='/'>Home</Link></h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default NotFoundPage;
